"use client";

import { Button } from "@cmp-src/primitives/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@cmp-src/primitives/dropdown-menu";
import { ChevronDown, Plus } from "lucide-react";
import React from "react";

interface InviteDropdownButtonProps {
  onInviteSingleGuest: () => void;
  onCopyRegistrationLink: () => void;
  onImportGuests?: () => void;
}

export const InviteDropdownButton: React.FC<InviteDropdownButtonProps> = ({
  onInviteSingleGuest,
  onCopyRegistrationLink,
  onImportGuests
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" className="gap-1">
          <Plus className="h-4 w-4" />
          Invite
          <ChevronDown className="h-3 w-3" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={onInviteSingleGuest}>
          Invite Single Guest
        </DropdownMenuItem>
        {onImportGuests && (
          <DropdownMenuItem onClick={onImportGuests}>
            Import guests
          </DropdownMenuItem>
        )}
        <DropdownMenuItem onClick={onCopyRegistrationLink}>
          Copy Registration Link
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
